<div class="dialog">
  <div class="row">
    <div class="col-4">
      <h4 mat-dialog-title>{{ data.title || 'common_search' | translate }}</h4>
    </div>
    <div class="col-8">
      <mat-slide-toggle *ngIf="data.favoriteData" [(ngModel)]="showOnlyFavorites" (change)="favoriteToggle()">{{ 'common_filter_favorites_only' | translate }}</mat-slide-toggle>
      <mat-slide-toggle *ngIf="data.fullDatabaseTree" [(ngModel)]="showFullDatabase" (change)="fullDatabaseToggle()">{{ 'common_filter_complete_database' | translate }}</mat-slide-toggle>
    </div>
  </div>
  <form #form="ngForm">
    <div class="row">
      <div class="col">
        <mat-form-field>
          <mat-label color="accent">{{ 'common_field_name' | translate }}</mat-label>
          <input matInput (keyup)="nameChanged($event.target)" />
        </mat-form-field>
      </div>
    </div>

    <div class="div-tree">
      <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
        <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle matTreeNodePadding>
          <button mat-icon-button disabled></button>
          <mat-checkbox class="checklist-leaf-node" [checked]="checklistSelection.isSelected(node)" (change)="leafItemSelectionToggle(node)">{{ node.displayName }} [{{ node.code }}]</mat-checkbox>
        </mat-tree-node>

        <mat-tree-node *matTreeNodeDef="let node; when: hasNoContent" matTreeNodePadding>
          <button mat-icon-button disabled></button>
        </mat-tree-node>

        <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding>
          <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.displayName">
            <mat-icon class="mat-icon-rtl-mirror">
              {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
            </mat-icon>
          </button>
          <ng-container *ngIf="!(editMode && isSingular); else categoryLabel">
            <mat-checkbox [checked]="descendantsAllSelected(node)" [indeterminate]="descendantsPartiallySelected(node)" (change)="itemSelectionToggle(node)">
              {{ node.displayName }}
            </mat-checkbox>
          </ng-container>
          <ng-template #categoryLabel>
            <span>{{ node.displayName }}</span>
          </ng-template>
        </mat-tree-node>
      </mat-tree>
    </div>
    <div mat-dialog-actions>
      <button mat-button (click)="onClickBack()">{{ 'common_btn_cancel' | translate }}</button>
      <button mat-button [mat-dialog-close]="onClickAdd()" color="accent" [disabled]="!form.valid">
        {{ editMode ? ('dialog_add_composition_btn_validate' | translate) : ('common_btn_add' | translate) }}
      </button>
    </div>
  </form>
</div>
